module.exports = __webpack_public_path__ + "static/img/5.0947e2e8.png";